import React, { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import useRoutesHelper from "../../../../hooks/useRoutesHelper";
import {
  getBinsFromVolume,
  postEndVolume,
} from "../../../../redux/api/expedition.api";
import TableWidget from "../../../../components/tables/TableWidget";
import {
  getShowBinsFromVolumesTableData,
  showBinsFromVolumeTableHeader,
} from "./components/tableConfigs/showBinsTableConfig";
import ContentCard from "../../../../components/misc/ContentCard";
import ShowBinsActionButtons from "./components/ActionButtons/ShowBinsActionButtons";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../helpers/apiHelper";
import { useNavigate } from "react-router-dom";
import DownloadBinFromVolumeModal from "../components/DownloadBinFromVolumeModal";

function ShowBinsFromVolume() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { routeMainParam } = useRoutesHelper();

  const { nrVolum } = routeMainParam as { nrVolum: string };

  const {
    expedition: {
      binsFromVolume: {
        nrColeteVolum,
        nrColeteVolumScanate,
        binuri: { data: binsFromVolumeData, total: totalBinsFromVolume },
        isLoading: isLoadingBinsFromVolume,
      },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  useEffect(() => {
    if (nrVolum) {
      dispatch(
        getBinsFromVolume({
          page: 1,
          per_page: 9999,
          nrVolum: nrVolum,
        }),
      );
    }
  }, [dispatch, nrVolum]);

  const packagesWithProblems = useMemo(
    () => binsFromVolumeData.some((bin) => bin.withProblems),
    [binsFromVolumeData],
  );

  const handleEndVolume = async () => {
    if (!nrVolum) return;
    const statusType = packagesWithProblems ? 3 : 4;

    const resultAction = await dispatch(
      postEndVolume({
        nrVolum: nrVolum,
        status: statusType,
      }),
    );

    if (
      checkEndpointStatus(resultAction, postEndVolume) ===
      endpointStatus.fulfilled
    ) {
      navigate(-1);
    }
  };

  return (
    <>
      <DownloadBinFromVolumeModal />

      {!isLoadingBinsFromVolume && (
        <ContentCard cardBodyClassName="flex items-center justify-between gap-4">
          <h1
            className={`${
              packagesWithProblems ? "text-danger" : "text-success"
            }`}>
            Colete scanate: {nrColeteVolumScanate}/{nrColeteVolum}
          </h1>

          <ActionMenu
            items={[
              {
                id: "close-volume",
                label: packagesWithProblems
                  ? "Inchidere volum cu neconformitati"
                  : "Inchidere volum",
                icon: "LOCK_CLOSE",
                color: "error",
                tooltip: !nrVolum
                  ? "Volumul trebuie sa aiba un identificator pentru inchidere."
                  : packagesWithProblems
                  ? "Inchide volumul cu neconformitatile detectate, dupa confirmare."
                  : "Inchide volumul dupa confirmare.",
                disabled: !nrVolum,
                withConfirmationModal: {
                  modalTitle: packagesWithProblems
                    ? "Inchidere volum cu neconformitati"
                    : "Inchidere volum",
                  modalSubtitle: "Doriti sa inchideti volumul?",
                  modalRightButtonText: "Da",
                  modalLeftButtonVariant: "outlined",
                  modalLeftButtonText: "Nu",
                  modalRightButtonOnClick: handleEndVolume,
                },
              },
            ]}
            minItemsForMenu={2}
            title={`Volum ${nrVolum}`}
            ariaLabel={`Actiuni pentru volumul ${nrVolum}`}
          />
        </ContentCard>
      )}
      <TableWidget
        tableHeaderData={showBinsFromVolumeTableHeader}
        tableItemsData={getShowBinsFromVolumesTableData(binsFromVolumeData)}
        totalItems={totalBinsFromVolume}
        tableLoading={isLoadingBinsFromVolume}
        ActionButtonsComponent={(props: any) => (
          <ShowBinsActionButtons {...props} />
        )}
        borderedRow
        withTablePagination={false}
      />
    </>
  );
}

export default ShowBinsFromVolume;
